import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import AboutUs from './components/AboutUs';
import CodexCrew from './components/CodexCrew';
import Workshop from './components/Workshop';
import Alumni from './components/Alumni'; // Import Alumni component
import Footer from './components/Footer';
import './App.css';

function App() {
  const [displayText, setDisplayText] = useState("Crew");
  const typingSpeed = 200; // Adjust typing speed here
  const pauseDuration = 1000; // Pause duration before switching

  useEffect(() => {
    const textInterval = setInterval(() => {
      setDisplayText((prev) => (prev === "Crew" ? "IGIT" : "Crew")); // Toggle between "Crew" and "IGIT"
    }, typingSpeed + pauseDuration);

    return () => clearInterval(textInterval);
  }, []);

  return (
    <div className="App">
      <Navbar />
      <section id="home" className="home">
        <div className="decorative-line top"></div> {/* Decorative top line */}
        <div className="home-content">
          <h1 className="home-title clickable">
            <span className="codex-text code-animation">Codex</span> <span className="crew-text code-animation">{displayText}</span>
          </h1>
          <p className="tagline clickable">Empowering Coders to Create</p>
        </div>
        <div className="decorative-line bottom"></div> {/* Decorative bottom line */}
      </section>
      <section id="about">
        <AboutUs />
      </section>
      <section id="codex-crew">
        <CodexCrew />
      </section>
      <section id="workshop">
        <Workshop />
      </section>
      <section id="alumni">
        <Alumni /> {/* Add the Alumni component */}
      </section>
      <Footer />
    </div>
  );
}

export default App;
